import React from 'react';
import { Switch } from '@headlessui/react';
import classnames from 'classnames';

const Toggle = ({ labels, toggle, toggleValue }) => {
  const [leftLabel, rightLabel] = labels;

  if (!(toggle || toggleValue || leftLabel)) return null;

  return (
    <div className="flex items-center justify-center">
      <div className="w-full max-w-xs mx-auto">
        <Switch.Group as="div" className="flex items-center space-x-4">
          <Switch.Label
            className={classnames('font-medium text-sm', {
              'text-light-haiti': toggleValue,
            })}
          >
            {leftLabel}
          </Switch.Label>
          <Switch
            as="button"
            checked={toggleValue}
            onChange={toggle}
            className="bg-cornflower relative inline-flex flex-shrink-0 h-6 transition-colors duration-200 ease-in-out border-2 border-transparent rounded-full cursor-pointer w-12 focus:outline-none focus:shadow-outline"
          >
            {({ checked }) => (
              <span
                className={`${
                  checked ? 'translate-x-6' : 'translate-x-0'
                } inline-block w-5 h-5 transition duration-200 ease-in-out transform bg-white rounded-full`}
              />
            )}
          </Switch>
          {rightLabel ? (
            <Switch.Label
              className={classnames('font-medium text-sm', {
                'text-light-haiti': !toggleValue,
              })}
            >
              {rightLabel}
            </Switch.Label>
          ) : null}
        </Switch.Group>
      </div>
    </div>
  );
};

export default Toggle;
